import { AbsenceRequestStatus } from "@/entities/absenceRequest/absenceRequest"

interface Props {
   selectedStatus: AbsenceRequestStatus | "all"
   setSelectedStatus: (status: AbsenceRequestStatus | "all") => void
}

export function AbsenceRequestFilterBar({ selectedStatus, setSelectedStatus }: Props) {
   return (
      <div className="filter-bar">
         <span className="label">Statut</span>

         <button
            className={`btn btn-sm ${selectedStatus === "all" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("all")}
         >
            Tous
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "pending" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("pending")}
         >
            En attente
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "validated_but_to_justify" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("validated_but_to_justify")}
         >
            Validée (à justifier)
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "validated" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("validated")}
         >
            Validée
         </button>
         <button
            className={`btn btn-sm ${selectedStatus === "rejected" ? "btn-neutral" : "btn-ghost"}`}
            onClick={() => setSelectedStatus("rejected")}
         >
            Refusée
         </button>
      </div>
   )
}
